module.exports = __webpack_public_path__ + "img/logo-blanco.bce3d3c6.png";